(function () {
  var path = window.location.pathname;
  if ((path === '/' || path === '') && window.location.search.indexOf('_fd=0') === -1) {
    var stale =
      document.querySelector('[id*="hero_p9CmMG"]') ||
      document.querySelector('.hero-wrapper') ||
      (document.querySelector('.header-section') && !document.querySelector('[id*="ch_home_hero"]'));
    if (stale) {
      var url = new URL(window.location.href);
      url.searchParams.set('_fd', '0');
      window.location.replace(url.toString());
      return;
    }
  }
})();

(function () {
  'use strict';

  function initFadeIn() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.ch-fade-in').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.ch-fade-in').forEach(function (el) {
      observer.observe(el);
    });
  }

  function initDrawer() {
    var toggle = document.querySelector('[data-ch-menu-toggle]');
    var drawer = document.querySelector('[data-ch-drawer]');
    var overlay = document.querySelector('[data-ch-drawer-overlay]');
    var closeBtn = document.querySelector('[data-ch-drawer-close]');

    function open() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }

    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    if (toggle) toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    if (drawer) {
      drawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', close);
      });
    }
  }

  function initGallery() {
    var filters = document.querySelectorAll('[data-ch-gallery-filter]');
    var items = document.querySelectorAll('[data-ch-gallery-item]');
    if (!filters.length) return;

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.getAttribute('data-ch-gallery-filter');
        filters.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        items.forEach(function (item) {
          var itemCat = item.getAttribute('data-category');
          item.style.display = cat === 'all' || itemCat === cat ? '' : 'none';
        });
      });
    });

    var lightbox = document.querySelector('[data-ch-lightbox]');
    var lightboxImg = document.querySelector('[data-ch-lightbox-img]');
    var closeBtn = document.querySelector('[data-ch-lightbox-close]');

    if (lightbox && lightboxImg) {
      items.forEach(function (item) {
        var img = item.querySelector('img');
        if (!img) return;
        item.addEventListener('click', function () {
          lightboxImg.src = img.getAttribute('data-full-src') || img.currentSrc || img.src;
          lightboxImg.alt = img.alt || '';
          lightbox.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        });
      });

      function closeLb() {
        lightbox.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      if (closeBtn) closeBtn.addEventListener('click', closeLb);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLb();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeLb();
      });
    }
  }

  function initRichContent() {
    document.querySelectorAll('.ch-rich-content').forEach(function (root) {
      if (root.dataset.chRichReady) return;
      var nodes = Array.prototype.slice.call(root.children);
      var pairs = [];
      for (var i = 0; i < nodes.length - 1; i++) {
        if (nodes[i].tagName === 'P' && nodes[i + 1].tagName === 'UL') {
          pairs.push([nodes[i], nodes[i + 1]]);
          i++;
        }
      }
      if (pairs.length < 2) {
        root.dataset.chRichReady = '1';
        return;
      }
      var grid = document.createElement('div');
      grid.className = 'ch-rich-content__grid';
      root.insertBefore(grid, pairs[0][0]);
      pairs.forEach(function (pair) {
        var col = document.createElement('div');
        col.className = 'ch-rich-content__col';
        col.appendChild(pair[0]);
        col.appendChild(pair[1]);
        grid.appendChild(col);
      });
      root.dataset.chRichReady = '1';
    });
  }

  function initServicesJumpNav() {
    var jump = document.querySelector('[data-ch-svc-jump]');
    if (!jump) return;
    var links = jump.querySelectorAll('[data-ch-svc-jump-link]');
    var sections = document.querySelectorAll('[data-ch-svc-section]');
    if (!links.length || !sections.length) return;

    function setActive() {
      var scrollY = window.scrollY + 120;
      var current = null;
      sections.forEach(function (section) {
        if (section.offsetTop <= scrollY) current = section.id;
      });
      links.forEach(function (link) {
        var href = link.getAttribute('href');
        var id = href ? href.replace('#', '') : '';
        link.classList.toggle('is-active', id && id === current);
      });
    }

    setActive();
    window.addEventListener('scroll', setActive, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFadeIn();
    initDrawer();
    initGallery();
    initRichContent();
    initServicesJumpNav();
  });
})();
